module.exports = __webpack_public_path__ + "static/img/tpbank.aa9fa8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tpbank.jpg
// module id = +6w9
// module chunks = 1